// extracted by mini-css-extract-plugin
export default {"ourPromise":"wA","promiseItems":"xA","promiseCard":"yA","cardTitle":"zA","cartText":"AA","promiseTitle":"BA"};
    if(module.hot) {
      // 1713996747196
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  